export default [
	{
		path: 'configurations/history/:module',
		name: 'configuration-history',
		//page title is dynamically set in the page
		// meta: {
		// 	pageTitle: 'Configuration History'
		// },
		props: route => ({
			module: route.params.module,
			searchParams: route.query
		}),
		component: () =>
			import(
				/* webpackChunkName: "configurationHistory" */ '@/sections/configurations/history/configuration-history-page.vue'
			)
	}
];
